<template>
  <div>
    <div>
      <p>
        {{ locale.debtorEmployees.totalCount }}
        <strong class="totalCount">
          {{ pagination.totalCount ? pagination.totalCount : 0 }}
        </strong>
        {{ locale.debtorEmployees.totalSum }}
        <strong class="totalCount">
          {{ totalSum ? totalSum : 0 }}
        </strong>
      </p>
    </div>
    <v-row>
      <v-col>
        <naj-data-table
          no-header
          :headers="headers"
          :loading="loading"
          :items="debtorEmployees.list"
          pagination
          :items-per-page="pagination.pageSize"
          :page-index="pagination.pageIndex"
          :server-items-length="pagination.totalCount"
          @update:pageIndex="onPageChange"
        >
        </naj-data-table>
      </v-col>
    </v-row>
    <naj-modal
      ref="addModal"
      :title="`${locale.debtorEmployees.debtorEmployee}`"
      :width="1200"
      show-footer-close-button
      @onClose="onCloseModal"
    >
      <debtor-employee
        :form-model="formModel"
        :loading="loading"
      ></debtor-employee>
    </naj-modal>
  </div>
</template>

<script>
import DebtorEmployee from './debtor-employee.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('BankruptcyModule');

export default {
  components: { DebtorEmployee },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      locale: this.local.bankruptcy.requestDetails,
      debtorEmployees: { list: [] },
      totalSum: 0,
      headers: [
        {
          value: 'index',
          text: this.local.bankruptcy.requestDetails.sequence,
        },

        {
          value: 'identityType',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.identityType,
        },
        {
          value: 'identityNumber',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.identityNumber,
        },
        {
          value: 'dateOfBirth',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.dateOfBirth,
        },
        {
          value: 'employeeName',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.theEmployee,
        },
        {
          value: 'nationalityName',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.nationality,
        },
        {
          value: 'mobile',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.mobile,
        },
        {
          value: 'email',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.email,
        },
        {
          value: 'salaryPerMonth',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.salaryPerMonth,
        },

        {
          value: 'duesValue',
          text: this.local.bankruptcy.requestDetails.debtorEmployees.duesValue,
        },

      ],
      pagination: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      formModel: {},
      loading: false,
    };
  },
  computed: {},
  mounted() {
    this.pagination.pageIndex = 0;
    this.loadData();
  },
  methods: {
    ...mapActions(['getDebtorEmployeesByRequestObjectKey', 'getDebtorEmployee']),
    loadData() {
      this.loading = true;
      this.totalSum = 0;
      this.getDebtorEmployeesByRequestObjectKey({
        requestObjectKey: this.requestObjectKey,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.loading = false;
          this.debtorEmployees = { ...data };
          this.debtorEmployees.list.forEach((element, index) => {
            element.index = index + 1 + (this.pagination.pageSize * this.pagination.pageIndex);
          });

          if (this.debtorEmployees.list.length)
            this.totalSum = this.debtorEmployees.list[0].totalSum;

          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });

    },
    onPageChange(pageIndex) {
      this.pagination = {
        ...this.pagination,
        pageIndex,
      };
      this.loadData();
    },
    showModal(model) {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: model.objectKey,
      };
      this.loading = true;
      this.getDebtorEmployee(params)
        .then((res) => {
          this.formModel = res.data;
          this.isEditMode = true;
          this.$refs.addModal.show();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCloseModal() {
      for (const key in this.formModel)
        if (Object.hasOwnProperty.call(this.formModel, key))
          this.$set(this.formModel, key, undefined);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}

.totalCount {
  padding: 6px;
  margin-right: 2px;
  margin-left: 13px;
  background-color: black;
  font-size: 13px;
  color: white;
}

div p {
  font-size: 15px;
}
</style>
